import { Link } from "react-router-dom"

import { ScaleLogo } from "@/domains/icons/brand/scale-logo"
import { cn } from "@/domains/library"

interface SiteLogoProps {
  className?: string
  forceLogoText?: boolean
  height?: number
  width?: number
}

export default function SiteLogo({ width = 158, height = 44, className }: SiteLogoProps) {
  return (
    <Link to={"/"} className={cn("flex cursor-pointer flex-row items-center gap-[8px]", className)}>
      <ScaleLogo height={height} width={width} />
    </Link>
  )
}
